<app-basic-card class="w-100" [css]="'mt-2'">
    <div class="policy-header-container">
        <div class="policy-number-container">
            <ng-container *ngIf="showLogo; else userBlock">
                <img [src]="getCompanyImage(item)" alt="company-logo" class="company-logo-img">
                <span class="policy-number-divider">|</span>
            </ng-container>
            <ng-template #userBlock>
                <mat-icon class="user-icon" aria-hidden="false" aria-label="user-icon" fontIcon="account_circle"></mat-icon>
            </ng-template>
            <span class="d-flex" (click)="goTo()">
                <span class="policy-label" [matTooltip]="tooltip" [ngClass]="{'hidden-input-field': hidePersonalData && !showLogo}">{{ title }}</span>
                <ng-container *ngIf="showArrow">
                    <mat-icon class="policy-label-icon" aria-hidden="false" aria-label="chevron_right-icon" fontIcon="chevron_right"></mat-icon>
                </ng-container>
            </span>
        </div>
        <ng-container *ngIf="showBadge">
            <div>
                <span class="badge" [ngClass]="getBadgeStyle(item?.policyType)" matTooltip="Tipologia">
                    {{ item?.policyType }}
                </span>
                <span class="mx-2">|</span>

                <span class="badge"  [ngClass]="getStatusBadgeStyle(item?.policyStatus)" matTooltip="Stato">
                    {{ item?.policyStatus }}
                </span>
            </div>
        </ng-container>
        @if (showVisibilityIcon) {
          <div>
              <ng-container >
                  <mat-icon class="visibility-icon" aria-hidden="false" aria-label="visibility-icon" fontIcon="visibility"
                      [matTooltip]="'Dettaglio'" (click)="detailCard()">
                  </mat-icon>
              </ng-container>
              <ng-container *ngIf="showDeleteIcon">
                  <mat-icon class="remove-icon" aria-hidden="false" aria-label="remove-icon" fontIcon="delete"
                      [matTooltip]="'Rimuovi'" (click)="deleteCard()">
                  </mat-icon>
              </ng-container>
          </div>
        }
    </div>
    <hr />
    <div class="policy-detail-container">
        <ng-container *ngFor="let key of keys">
            <div [ngClass]="isCustomerCard ? 'policy-customer-detail-item' : 'policy-detail-item'">
                <p class="policy-detail-label">{{key?.label}}</p>
                <p class="policy-detail-value" *ngIf="key?.key; else defaultValue" [ngClass]="{'hidden-input-field': key.hidden && hidePersonalData}">{{ getValue(item, key) }}</p>
                <ng-template #defaultValue>
                    <p>{{ key?.defaultValue }}</p>
                </ng-template>
            </div>
        </ng-container>
        <ng-container *ngFor="let placeholder of getPlaceholders(keys?.length)">
            <div [ngClass]="isCustomerCard ? 'policy-customer-detail-item' : 'policy-detail-item'"></div>
        </ng-container>
    </div>
</app-basic-card>
